
import * as React from 'react';
import { TextField } from '../text/TextField';

/**
 * @public
 */
export interface ILocationFieldProps {
  displayName?: string;
  locationId?: string;
}

/**
 * @public
 */
export const LocationField: React.StatelessComponent<ILocationFieldProps> = (props: ILocationFieldProps) => {
  return props.displayName ?
    (
      <TextField text={ props.displayName } />
    ) : null;
};
